import styled from "styled-components";

export {}; // 추가: 모듈로 만들기 위한 빈 export

export const HeroSection = styled.div`
  width: calc(100% - 80px);
  max-width: 2560px;
  padding: 120px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  margin-bottom: 120px;
  position: relative;
  min-height: 600px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background-image: url("/images/about-background.webp");
    background-size: cover;
    background-position: center;
    z-index: 0;
  }

  &::after {
    content: "";
    position: absolute;
    top: 20%;
    right: -30px;
    width: 200px;
    height: 200px;
    background-image: url("/images/logo_bogun_3x.png");
    background-size: contain;
    background-repeat: no-repeat;
    z-index: 1;
  }

  @media (max-width: 768px) {
    min-height: 400px;

    &::before {
      width: 40%;
      height: 60%;
      top: 100px;
      right: 0;
      background-position: top right;
    }

    &::after {
      top: 60px;
      right: 20px;
      width: 200px;
      height: 150px;
    }
  }
`;

export const MainTitle = styled.h1`
  color: #000;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Pretendard;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 68px;
  margin-bottom: 40px;
  white-space: pre-line;
  color: #333;
  position: relative;
  z-index: 2;
  margin-top: 200px;

  @media (max-width: 768px) {
    font-size: 32px;
    margin-top: 250px;
  }
`;

export const Description = styled.p`
  color: rgba(0, 0, 0, 0.8);
  font-feature-settings: "liga" off, "clig" off;

  /* Regular/body-L-400 */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  max-width: 800px;
  margin: 0 0 0px;
  white-space: pre-line;
  position: relative;
  z-index: 2;
  margin-top: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0;
  }
`;

export const DescriptionEng = styled.p`
  color: rgba(0, 0, 0, 0.8);
  font-feature-settings: "liga" off, "clig" off;

  /* Regular/body-S-400 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  white-space: pre-line;
  z-index: 2;

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 0;
  }
`;

export const TeamSection = styled.div`
  background-color: #f8f9fa;
  padding: 80px 20px;
`;

export const SectionTitle = styled.h2`
  text-align: left;
  color: #333;
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 20px;
  color: var(--Black-black, #000);
  font-family: Montserrat;
  font-size: 58px;
  font-style: normal;
  font-weight: 600;
  line-height: 71px; /* 122.414% */
  white-space: pre-line;
`;

const GridCommonStyles = `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TeamGrid = styled.div`
  ${GridCommonStyles}

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
    padding: 0 20px;
  }
`;

export const AdvisorGrid = styled.div`
  ${GridCommonStyles}
`;

export const MemberCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const MemberImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  margin-bottom: 20px;
  // filter: grayscale(100%);
  transition: filter 0.3s ease;

  &:hover {
    filter: grayscale(0%);
  }

  @media (max-width: 768px) {
    width: 140px;
    height: 140px;
  }
`;

export const MemberName = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  display: inline;
`;

export const MemberPosition = styled.span`
  font-size: 17px;
  font-weight: 400;
  color: #333;
  display: inline;
  margin-left: 8px;
`;

export const NamePositionWrapper = styled.div`
  margin-bottom: 16px;
`;

export const MemberCareer = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: left;

  p {
    margin: 4px 0;
  }
`;

export const AdvisorSection = styled(TeamSection)`
  background-color: white;
`;
